import * as types from '../mutation-types'
import users from '../../api/users'

// state
export const state = {
    data: [],
}

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.SET_USERS](state, data) {
        var users = data.data

        state.data = users
    },
}

// actions
export const actions = {
    getAllUsers ({ commit }) {
        users.getUsers((users) => {
            commit(types.SET_USERS, {'data': users})
        })
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/users.js